import styled from 'styled-components';

export const Title = styled.h2`
  font-family: 'Cormorant Garamond', serif;
  font-style: italic;
  font-size: 32px;
  font-weight: 300;
`;
